import React from "react";
import { Box, Typography, Checkbox, FormControlLabel } from "@mui/material";
import { daysOfWeek } from "../../../constants/string";

const OrderTakingDays = ({ orderTakingDays, setOrderTakingDays }) => {

  const selectedDays = orderTakingDays.split(",").map(Number);

  const handleChange = (dayIndex) => {
    const actualDayIndex = dayIndex + 1; // Adjust to 1-based index
    const updatedDays = selectedDays.includes(actualDayIndex)
      ? selectedDays.filter((day) => day !== actualDayIndex)
      : [...selectedDays, actualDayIndex];

    setOrderTakingDays(updatedDays.join(","));
  };

  return (
    <Box my={1}>
      <Typography variant="h6" gutterBottom align="left">
       Storefront Order Taking Days
      </Typography>
      <Box sx={{ textAlign: "left" }}>
        {daysOfWeek.map((day, index) => (
          <FormControlLabel
            key={day}
            control={
              <Checkbox
                checked={selectedDays.includes(index + 1)}
                onChange={() => handleChange(index)}
              />
            }
            label={day}
            sx={{ textAlign: "left" }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default OrderTakingDays;
